import "./App.css";
import Routes from "./router/index";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { initAxios } from "./utilities/utilities";
import { useEffect } from "react";

const App = () => {
  initAxios(null);

  // Comprehensive ResizeObserver error suppression
  useEffect(() => {
    // Override ResizeObserver constructor to prevent errors
    let OriginalResizeObserver: typeof window.ResizeObserver;
    if (typeof window !== 'undefined' && window.ResizeObserver) {
      OriginalResizeObserver = window.ResizeObserver;
      window.ResizeObserver = class SafeResizeObserver extends OriginalResizeObserver {
        constructor(callback: ResizeObserverCallback) {
          super((entries, observer) => {
            try {
              callback(entries, observer);
            } catch (error: any) {
              // Silently ignore ResizeObserver errors
              if (error?.message?.includes?.('ResizeObserver')) {
                return;
              }
              throw error;
            }
          });
        }
      };
    }

    // Suppress console errors for ResizeObserver
    const originalError = window.console.error;
    const originalWarn = window.console.warn;

    window.console.error = (...args) => {
      if (args[0]?.includes?.('ResizeObserver loop completed with undelivered notifications')) {
        return;
      }
      if (args[0]?.includes?.('ResizeObserver loop limit exceeded')) {
        return;
      }
      if (args[0]?.includes?.('ResizeObserver')) {
        return;
      }
      originalError.apply(window.console, args);
    };

    window.console.warn = (...args) => {
      if (args[0]?.includes?.('ResizeObserver')) {
        return;
      }
      originalWarn.apply(window.console, args);
    };

    // Suppress global error events
    const handleError = (event: ErrorEvent) => {
      if (event.message?.includes?.('ResizeObserver')) {
        event.preventDefault();
        return false;
      }
    };

    // Suppress unhandled promise rejections
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (event.reason?.message?.includes?.('ResizeObserver')) {
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      // Restore original ResizeObserver
      if (typeof window !== 'undefined' && window.ResizeObserver && OriginalResizeObserver) {
        window.ResizeObserver = OriginalResizeObserver;
      }

      window.console.error = originalError;
      window.console.warn = originalWarn;
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
};

export default App;
